import type { ProductColor } from '@aloft/toolkit-shared';

import type { PropsWithChildren } from 'react';

import { Table as PDFTable } from '../../components/pdf-export/Table/Table.tsx';
import { Table as WebTable } from '../../components/table.tsx';
import { useIsPDF } from '../internal/useIsPDF.ts';

type Props = PropsWithChildren<{
  backgroundColor?: ProductColor;
}>;

export const Table = (props: Props) => {
  const { children, ...rest } = props;
  return useIsPDF() ? (
    <PDFTable {...rest}>{children}</PDFTable>
  ) : (
    <WebTable {...rest}>{children}</WebTable>
  );
};
